import React from "react";
import "./ProductRange.css";

// Use your actual image imports here
import Plastic3D from "../../Gallery/Plastic-3D-Printing.jpg";

import InjectionM from "../../Gallery/im.jpg";
import img1 from "../../Gallery/1.jpeg";

import img2 from "../../Gallery/Engineering_spares.png";
import img3 from "../../Gallery/Laser_Cutting.png";




function ProductRange() {
  const products = [
    {
      title: "3D Metal Printing",
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=1000", 
      desc: "DMLS technology for Titanium & Steel.",
    },
    {
      title: "3D Plastic Printing",
      image: Plastic3D,
      desc: "SLA/SLS functional prototypes.",
    },
    {
      title: "Injection Molding",
      image: InjectionM,
      desc: "High-volume OEM components.",
    },

    {
      title: "Sheet Metal",
      image: img1,
      desc: "High-volume OEM components.",
    },

     {
      title: "Engineering spares",
      image: img2,
      desc: "High-volume OEM components.",
    },

     {
      title: "Laser Cutting",
      image: img3,
      desc: "High-volume OEM components.",
    },
    
   
  ];

  return (
    <section className="pr_fullscreen">
      <div className="pr_inner_wrapper">
        <div className="pr_header_compact">
          <h2>Our <span>Product Range</span></h2>
          <p>Advanced engineering solutions in one glance.</p>
        </div>

        <div className="pr_bento_grid">
          {products.map((item, index) => (
            <div 
              key={index} 
              className="pr_bento_card"
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className="pr_card_overlay">
                <div className="pr_card_info">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductRange;